// extracted by mini-css-extract-plugin
export default {"label":"C93BTFYJNLGnjwOJD9aK"};